/*
    Форма информации о животном
*/

import './FormAnimal.css';
import '../css/Main.css';
import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom';
import axios_sender from '../modules/axios_sender.js'
import unique from '../modules/unique.js'
import parseDate from '../modules/date.js'
import SelectAnimalModal from './SelectAnimalModal.js';
import TextBox from '../elements/TextBox.js';
import Select from '../elements/Select.js';
import { GetGlobalClient } from '../modules/client.js'
import { SetGlobalAnimal } from '../modules/animal.js'



class FormAnimal extends React.Component {
  constructor(props, ref) {
    super(props, ref);  
    
    // привязка this к событию
    this.SetSelectAnimal = this.SetSelectAnimal.bind(this);
    this.LoadAnimalTypesSuccess = this.LoadAnimalTypesSuccess.bind(this);
    this.LoadAnimalSex = this.LoadAnimalSex.bind(this);
    this.LoadYears = this.LoadYears.bind(this);
    this.LoadMonths = this.LoadMonths.bind(this);
    this.SelectAnimalCancel = this.SelectAnimalCancel.bind(this);
    this.SelectedAnimalSuccess = this.SelectedAnimalSuccess.bind(this);
    this.AddNewAnimal = this.AddNewAnimal.bind(this);
    this.GetSelectedData = this.GetSelectedData.bind(this);
    

    // отслеживаемые переменные
    this.state = {
        list_animal_type: [],             // список типов животных
        list_animal_sex: [],              // список полов животных
        animal_born_year: [],             // список рождения животного (год)
        animal_born_month: [],            // список рождения животного (месяц)

        selected_animal_id: "",           // ID животного
        selected_animal_name: "",         // кличка животного
        selected_animal_type: "",         // выбранный тип животного
        selected_animal_sex: "",          // выбранный пол животноГО
        selected_born_year: "",           // выбранный год рождения
        selected_born_month: "",          // выбранный месяц рождения
        selected_animal_weight: "",       // выбранный вес животного

        is_display_animal_select: false,  // показывать ли модальное окно выбора животного
        client: [],                       // выбранный клиент

        navigate_to_history: false,       // для перехода на страницу истории
    };

  }
  

  componentDidMount()
  {
      this.LoadAnimalTypes();       // загрузим типы животных
      this.LoadAnimalSex();         // загрузим пол животных
      this.LoadYears();             // загрузим года
      this.LoadMonths();            // загрузим месяцы
      this.state.client = GetGlobalClient();
  }

  componentDidUpdate(prevProps, prevState)
  {
      if(prevProps.SelectedAnimal !== this.props.SelectedAnimal) this.SetSelectAnimal(this.props.SelectedAnimal);
  }

  SetSelectAnimal(animal)
  {
      if(animal === undefined || animal == null) return;
      this.setState({
                  selected_animal_id: animal.ID, 
                  selected_animal_name: animal.animal_name,
                  selected_animal_type: animal.animal_type,
                  selected_animal_sex: animal.animal_sex,
                  selected_born_year: parseDate(animal.animal_born)['year'],
                  selected_born_mohth: parseDate(animal.animal_born)['month'],
                  selected_animal_weight: animal.animal_weight,
             });    
  }

  // возвращает выбранные пользователем данные
  GetSelectedData()
  {
      return {
            ID: this.state.selected_animal_id, 
            animal_name: this.state.selected_animal_name,
            animal_type: this.state.selected_animal_type,
            animal_sex: this.state.selected_animal_sex,
            animal_born_year: this.state.selected_born_year,
            animal_born_month: this.state.selected_born_month,
            animal_born: this.state.selected_born_year + "-" + this.state.selected_born_month + "-01",
            animal_weight: this.state.selected_animal_weight,
      };
  }

  render() {

      if (this.state.navigate_to_history)   return <Navigate to="/history" replace={false} />;

      return (
            <>
            <div className="page-caption-2">Информация о животном</div>
                  <div className="input-group mb-1">
                        <span className="input-group-text col-4">{ this.state.selected_animal_id }</span>
                        <span className="form-control ID" onClick={ (e) => this.setState({ is_display_animal_select: true }) } >ВЫБРАТЬ ИЗ СПИСКА</span>                          
                  </div>
                  <div className="input-group mb-1">
                        <span className="input-group-text col-4">Кличка</span>
                        <TextBox cnTextBox="col input-group-text"
                              caption="Имя животного"
                              value={ this.state.selected_animal_name }
                              onChange={ (v) => this.setState({ selected_animal_name: v })}
                              />
                  </div>

                  
                  <div className="input-group mb-1">
                        <span className="input-group-text col-4">Тип</span>    
                        <Select cnSelect="form-control text-start"
                              onChange={ (v) => this.setState({ selected_animal_type: v }) }                              
                              value={ this.state.selected_animal_type }
                              options={ this.state.list_animal_type }
                              caption="Выбор типа животного"
                              />                              
                        
                  </div>


                  <div className="input-group mb-1">
                        <span className="input-group-text col-4">Пол</span>    
                        <Select cnSelect="form-control text-start"
                              onChange={ (v) => this.setState({ selected_animal_sex: v }) }
                              value={ this.state.selected_animal_sex }
                              options={ this.state.list_animal_sex }
                              caption="Выбор пола животного"
                              />                              
                        
                  </div>
                  <div className="input-group mb-1">
                        <span className="input-group-text col-4">Дата рожд.</span>
                        <select className="form-control col-2" value={ this.state.selected_born_year }
                              onChange={ (e) => this.setState({ selected_born_year: e.target.value }) }>
                              { this.state.animal_born_year }
                        </select>
                        <select className="form-control col-2" value={ this.state.selected_born_month }
                              onChange={ (e) =>  this.setState({ selected_born_month: e.target.value }) }                              
                              >
                              { this.state.animal_born_month }
                        </select>                         
                  </div>
                  <div className="input-group mb-1">
                        <span className="input-group-text col-4">Вес</span>
                        <TextBox cnTextBox="col input-group-text"
                              caption="Вес животного"
                              value={ this.state.selected_animal_weight }
                              onChange={ (v) => this.setState({ selected_animal_weight: v })}
                              />
                  </div>

                  <br /><br />

                  <div>
                        <button type="button" className="btn btn-primary btn-lg" onClick={ () => this.AddNewAnimal() }>Сохранить и выбрать</button>
                  </div>


                  { this.state.is_display_animal_select && (<SelectAnimalModal Client={ this.state.client } SelectedAnimalSuccess={ this.SelectedAnimalSuccess } CancelSelect = { this.SelectAnimalCancel } />) }

            </>
      );
  }

//#region   [ЗАГРУЗКА ВЫПАДАЮЩИХ СПИСКОВ]
  
  // загрузка типов животных из БД
  LoadAnimalTypes() { axios_sender({form: 'get_animal_types'}, this.LoadAnimalTypesSuccess); } 
  LoadAnimalTypesSuccess(data)
  {
      let lat = [];
      //for(var i in data) lat.push(<option key={ unique() } value={ data[i].ID }>{ data[i].name }</option>);
      for(var i in data) lat.push({value: data[i].ID, label: data[i].name });
      this.setState({
            list_animal_type: lat,
            //selected_animal_type: lat[0].props.value
      });      
  }
  // подготовка списка полов животных
  LoadAnimalSex()
  {      
      axios_sender({form: 'get_animal_sex'}, (data) => {            
            let sex = [];
            for(var i in data) sex.push({ value: data[i].ID, label: data[i].name });
            this.setState({ list_animal_sex: sex });
      });
  }

  // загрузка годов для даты рождения
  LoadYears()
  {
      let year = new Date().getFullYear();
      let years = [];
      for(let i = 0; i < 35; i++) years.push(<option key={ unique() } value={ year - i }>{ year - i }</option>);
      this.setState({
            animal_born_year: years,
            selected_born_year: years[0].props.value
      });
  }
  // загрузка месяцев для даты рождения
  LoadMonths()
  {      
      let mons = [];      
      for(let i = 1; i <= 12; i++) mons.push(<option key={ unique() } value={ i }>{ i }</option>);
      this.setState({
            animal_born_month: mons,
            selected_born_mohth: mons[0].props.value
      });
  }
//#endregion


  // пользователь решил выбрать животное из списка
  SelectedAnimalSuccess(animal)
  {
      SetGlobalAnimal(animal);
      this.props.SelectedAnimal(animal);
      //this.setState({ is_display_animal_select: false });

      // Перейдём на страницу истории приёмов животного
      console.log("Перейдём на страницу истории приёмов животного");
  }
  // пользователь отказался выбирать животное
  SelectAnimalCancel()
  {
      this.setState({ is_display_animal_select: false });
  }

  // пользователь сохраняет новое животное
  AddNewAnimal()
  {
      var animal = this.GetSelectedData();
      if(animal.ID > 0)
      {
            alert("Не новое животное");
            return;
      }
      const client_ID =this.state.client.ID;
      if(client_ID === undefined || client_ID == null || client_ID == "" || client_ID < 1)
      {
            alert("Не выбран владелец");
            return;
      }
      axios_sender({form: 'create_animal', animal: animal, id_client: client_ID }, () => {});
      SetGlobalAnimal(animal);
      this.props.SelectedAnimal(animal);      

      // Перейдём на страницу истории приёмов животного
      this.setState({ navigate_to_history: true });
      //this.context.history.push('/history');      
  }



}


export default FormAnimal;
